module.exports = __webpack_public_path__ + "img/img_consulta_agendar.8fae2e02.svg";